import React from 'react'; 
import { Socials } from '../datafiles/Socials';

const SocIcons = () => {

  const handleClick = (path) => {
    window.open(path, '_blank'); // Open URL in a new tab
  };

  const Icon = ({ name, path, imgUrl, disabled }) => (
    <div
      className={`flex justify-center items-center hover:scale-110 ${!disabled && 'cursor-pointer'}`}
      onClick={() => handleClick(path)} // Pass path to handleClick
      style={{
        width: '64px',
        height: '64px',
        borderRadius: '16px',
      }}
    >
      <img
        src={imgUrl}
        alt={name}
        style={{
          width: '32px',
          height: '32px',
        }}
      />
    </div>
  );

  return (
    <div className="flex flex-row justify-center mb-[2em]">
      {Socials.map((item, index) => (
        <Icon
          key={index}
          name={item.name}
          path={item.path} 
          imgUrl={item.imgUrl}
          disabled={item.disabled}
        />
      ))}
    </div>
  );
};

export default SocIcons;
